import StatsCounter from './StatsCounter'

export default StatsCounter
